import { useCallback, useEffect, useState } from 'react';
export const isSsr = typeof window === 'undefined';
export const isIntersectionObserverAvailable = isSsr
    ? false
    : !!window.IntersectionObserver;
export const universalBtoa = (str) => isSsr
    ? Buffer.from(str.toString(), 'binary').toString('base64')
    : window.btoa(str);
export function useImageLoad(ref, callback) {
    const [loaded, setLoaded] = useState(false);
    function handleLoad() {
        setLoaded(true);
        callback === null || callback === void 0 ? void 0 : callback();
    }
    // https://stackoverflow.com/q/39777833/266535
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        if (ref.current.complete && ref.current.naturalWidth) {
            handleLoad();
        }
    }, []);
    return [loaded, handleLoad];
}
export function useMergedRef(...refs) {
    return useCallback((element) => {
        for (let i = 0; i < refs.length; i++) {
            const ref = refs[i];
            if (typeof ref === 'function')
                ref(element);
            else if (ref && typeof ref === 'object')
                ref.current = element;
        }
    }, refs);
}
export const absolutePositioning = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none',
};
//# sourceMappingURL=utils.js.map